/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';


const SortationHeading = ({ children, ...props }) => (
  <div
    css={css`
      margin: 10px 0;
    `}
  >
    {children}
  </div>
);

export default SortationHeading;
